import { Panel } from "primereact/panel";
import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useRef, useState } from "react";
import { Parametrizacion } from "./Parametrizacion";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { GenericComponent } from "../../components/GenericComponent";

export const Configuracion = () => {
    const [permss, setPermss] = useState(null);
    const monitoreoService = new MonitoreoService();
    const toast = useRef(null);
    const generic = new GenericComponent();

    useEffect(() => {
        inicio();
    }, []);

    const inicio = () => {
        monitoreoService.consultar(0, 'monitoreo/configuracion/permission').then(res => {
            setPermss(res.data.perss);
        });
    }

    const [activeIndex, setActiveIndex] = useState(0);
    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Panel>
                {permss &&
                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                        <TabPanel header="Parámetros">
                            <Parametrizacion permss={permss} toast={toast} generic={generic} />
                        </TabPanel>
                    </TabView>
                }
            </Panel>
        </>
    )
}
